@if (!!configuration && hasFeatureFlag(FeatureFlagEnum.DashCam)) {
  <div class="drawer-layout">
    @for (item of items; track $index) {
      <div class="drawer-selected-wrapper"
           [ngClass]="{ selected: item.id === selectedVehicle?.id }"
      >
        <div class="drawer-content">
          <app-action-menu-item [input]="item">
          </app-action-menu-item>
        </div>

        @if (item.id === selectedVehicle?.id) {
          @if (selectedVehicle.shiftStatus === ShiftState.ENDED) {
            <div class="drawer-content">
              <span>Vehicle is offline</span>
            </div>
          } @else {
            @if (selectedVehicle.cameraConfiguration?.streaming?.captureStreamDuration > 0) {
              <div class="drawer-content">
                <div class="drawer-title">Livestream</div>

                @if (!streaming) {
                  <button mat-button
                          mat-stroked-button
                          color="accent"
                          (click)="startStreaming(videoPlayer)"
                          class="stream-button"
                  >
                    <mat-icon>play_arrow</mat-icon>
                    <!--<mat-icon *ngIf="streaming">sync</mat-icon>-->
                    @if (firstTimeStreaming) {
                      <span>Start Livestream</span>
                    } @else {
                      <span>Continue Livestream</span>
                    }
                  </button>
                }

                <app-video-player [vehicleId]="selectedVehicle.id"
                                  [timeFrom]="selectedVehicle.shiftStartTime"
                                  #videoPlayer
                ></app-video-player>
              </div>
            }

            @if (selectedVehicle.cameraConfiguration?.streaming?.captureImageInterval > 0) {
              <div class="drawer-content">
                <div class="drawer-title">Captured Images</div>

                @if (!images) {
                  <mat-spinner></mat-spinner>
                } @else {
                  @if (images.length === 0) {
                    <div>
                      No still images
                    </div>
                  } @else {
                    <app-image-viewer
                      [images]="images"
                    ></app-image-viewer>
                  }
                }
              </div>
            }

            @if (!selectedVehicle.cameraConfiguration?.streaming?.captureImageInterval &&
              !selectedVehicle.cameraConfiguration?.streaming?.captureStreamDuration
            ) {
              <div>
                Insufficient dashcam configuration, none of the dashcam options is selected (livestreaming, capturing images on interval)
              </div>
            }
          }
        }
      </div>
    }
  </div>
}
